import { cdnClient, client, PartnersTypes, ResponseData } from '../galaxyClient';

export async function getDonationProgramById(donationProgramId: string) {
  const { data } = await cdnClient().partners.GET('/v2/donation-programs/{id}', {
    params: {
      path: {
        id: donationProgramId,
      },
    },
  });

  return data;
}

export async function getDonationProgramsBySlug(slug: string) {
  const { data } = await cdnClient().partners.GET('/v2/donation-programs/', {
    params: {
      query: {
        slug,
      },
    },
  });

  return data;
}

export type DonationProgramOptions = ResponseData<
  PartnersTypes,
  '/v2/donation-programs/{donationProgramId}/options/{id}',
  'get'
>;
export async function getDonationProgramPreviewOptions(donationProgramId: string) {
  const { data } = await client().partners.GET(
    '/v2/donation-programs/{donationProgramId}/options/',
    {
      params: {
        path: {
          donationProgramId,
        },
        query: {
          status: ['PREVIEW', 'PUBLISHED'],
        },
      },
    },
  );

  const previewOption = data.result.find((option) => option.status === 'PREVIEW');
  if (previewOption) {
    return previewOption;
  }

  // This means we only have a published option
  return data.result[0];
}

export async function getDonationProgramPublishedOptions(donationProgramId: string) {
  const { data } = await cdnClient().partners.GET(
    '/v2/donation-programs/{donationProgramId}/options/',
    {
      params: {
        path: {
          donationProgramId,
        },
        query: {
          status: ['PUBLISHED'],
        },
      },
    },
  );

  const [options] = data.result;

  return options;
}

export const getPaymentRequestByPayload = async ({ payload }: { payload: string }) => {
  const { data } = await client().partners.GET('/v2/payment-requests/claim', {
    params: {
      header: { payload },
    },
  });

  return data;
};

export const claimDonation = async ({ payload }: { payload: string }) => {
  const { data } = await client().partners.POST('/v2/payment-requests/claim', {
    body: { payload },
  });

  return data;
};

export const getPartner = async ({ id }: { id: string }) => {
  const { data } = await cdnClient().partners.GET('/v2/partners/{id}', {
    params: {
      path: {
        id,
      },
    },
  });

  return data;
};

export const getPartnerProfile = async ({ id }: { id: string }) => {
  const { data } = await cdnClient().partners.GET('/v2/profiles/{id}', {
    params: {
      path: {
        id,
      },
    },
  });

  return data;
};

type ValidCurrencyCode = 'EUR' | 'SEK' | 'USD' | undefined;
export async function getDonationProgramMetrics(
  donationProgramId: string,
  currencyCode: string | undefined | null = undefined,
  status?: 'PREVIEW' | 'PUBLISHED',
) {
  const { data } = await cdnClient().partners.GET('/v2/donation-programs/{id}/metrics', {
    params: {
      query: {
        currencyCode: currencyCode as ValidCurrencyCode,
        status,
      },
      path: {
        id: donationProgramId,
      },
    },
  });

  return data;
}
